<template>
  <div class="pwaInstall-box" v-if="showPwaInstall">
    <a
      v-if="pwaAwardConfig.open"
      href="javascript:;"
      class="new-add-to-home"
      @click="isSafari ? showSafariTip() : installPwa()"
    >
      <div class="new-add-to-home-text">
        <p>{{ letter.pwaInstallAward }}</p>
        <p>{{ letter.getAward }}</p>
      </div>
    </a>
    <a
      v-else
      href="javascript:;"
      class="add-to-home j-add-to-home"
      @click="isSafari ? showSafariTip(true) : installPwa(true)"
    >
      <em class="ico iconfont icon-tag"></em>
      <span class="text">{{ letter.voucherAddHome }}</span>
    </a>
    <transition name="fade">
      <safari-pwa-guide-popup
        v-if="isGuide"
        @closePopup="hideSafariTip"
      ></safari-pwa-guide-popup>
    </transition>
    <transition name="fade">
      <pwa-install-award-popup
        v-if="visibleInstallAwardPopup"
        @install="pwaInstallFromPopup"
        @close="closePwaInstallAwardPopup"
      ></pwa-install-award-popup>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import { commonEmitUpload } from '../../plugins/AnalyzePoint/index';
import { isSafari } from '@utiles/officialStore/device';
import SafariPwaGuidePopup from '@components/officialStore/SafariPwaGuidePopup.vue';
import PwaInstallAwardPopup from '@components/officialStore/PwaInstallAwardPopup.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import { mapGetters } from 'vuex';
import {
  popupType,
  showPopup,
  clickButton
} from '@plugins/biPoint/_configWebstoreV1';
import { UPDATE_IS_INSTALL } from '@store/officialStore/page';
export default {
  emits: ['isInstallUpdate'],
  components: { SafariPwaGuidePopup, PwaInstallAwardPopup },
  name: 'PwaInstall',
  data() {
    return {
   
      isSafari: isSafari(),
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut') ||
        globalConfig.getHrefParam('mode') === 'pwa',
      isGuide: false,
      visibleInstallAwardPopup: false
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    showPwaInstall() {
      return (
        !this.isHideAdd && // pwa进入不展示
        (this.isSafari || !this.isInstall) && // 已安装不展示，safari展示
        !this.isJpPlatform // 日本平台不展示
      );
    },
    isInstall() {
      return this.$store.state.page.isInstall.value;
    },
     gameId() {
      return this.$store.state.gameId;
    },
    ...mapGetters(['isJpPlatform', 'pwaAwardConfig'])
  },
watch: {
  isInstall(newVal) {
    if(newVal == false) {
      this.isAutoShowPwaPopup();
    }
  }
},
  mounted() {
    this.isAutoShowPwaPopup();
    // app安装了
    window.addEventListener('appinstalled', () => {
      this.setIsInstall();
      // 回收 deferredPrompt 变量
      window.deferredPrompt = null;
      // pwa成功安装
      commonEmitUpload('success-install-pwa', {
        event: 'success-install-pwa',
        newPage: false,
        type: 'change'
      });
    });
  },
  methods: {
    setIsInstall() {
      this.$emit('isInstallUpdate', true);
      // this.isInstall.value = true;
      this.$store.commit(UPDATE_IS_INSTALL, true);
    },
    showSafariTip(isNew = false) {
      this.isGuide = true;
      clickButton({
        btnName: isNew ? 'add_to_screen_now' : 'add_to_screen',
        locationKey: this.$route.meta.pageName
      });
      showPopup(popupType.safariAddToHomePopup);
    },
    hideSafariTip() {
      this.isGuide = false;
    },
    updateUrlWithParams(currentUrl, newParams) {
      // 解析当前 URL
      const url = new URL(currentUrl);
      // 遍历并更新/添加新的查询参数
      Object.keys(newParams).forEach(key => {
        url.searchParams.set(key, newParams[key]);
      });
      // 返回更新后的 URL 字符串
      return url.toString();
    },
    installPwa(isNew = false) {
      // 用户点击页面上的安装按钮
      commonEmitUpload('click-install-pwa-btn', {
        event: 'click-install-pwa-btn',
        newPage: false,
        type: 'click'
      });
      clickButton({
        btnName: isNew ? 'add_to_screen_now' : 'add_to_screen',
        locationKey: this.$route.meta.pageName
      });
      if (!window.deferredPrompt) return;
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then(result => {
        if (result.outcome == 'dismissed') {
          // 用户点击页面上的安装按钮
          commonEmitUpload('cancel-install-pwa', {
            event: 'cancel-install-pwa',
            newPage: false,
            type: 'click'
          });
        } else if (result.outcome == 'accepted') {
          window.setIsInstall();
          this.setIsInstall();
          window.deferredPrompt = null;

          // 用户点击页面上的安装按钮
          commonEmitUpload('accept-install-pwa', {
            event: 'accept-install-pwa',
            newPage: false,
            type: 'click'
          });

               // 2026-01-21 存一下，用来刷新页面后展示领奖提示弹窗
          try {
             sessionStorage.setItem(`${this.gameId}_pwa_install_click`, 1);
          } catch (error) {
            
          }



          // 2025-01-08 同manifest动态生成的参数链接一致
          const curCid = globalConfig.getHrefParam('cid');
          const curScid = globalConfig.getHrefParam('scid');
          try {
            let link = this.updateUrlWithParams(window.location.href, {
              cid: curCid,
              scid: curScid,
              mode: 'pwa'
            });
            window.location.href = window.globalGetGotoLink({ link });
          } catch (e) {
            console.error(e);
          }
        }
        // 接受了安装才会返回平台，没有接受不会返回平台
        // console.log('Install platform: ' + result.platform);
      });
    },
    pwaInstallFromPopup() {
      this.closePwaInstallAwardPopup();
      this.isSafari ? this.showSafariTip(true) : this.installPwa(true);
    },
    closePwaInstallAwardPopup() {
      this.visibleInstallAwardPopup = false;
    },
    switchVisiblePwaInstallAwardPopup(bool) {
      this.visibleInstallAwardPopup = bool;

      if (bool) {
        // 记录本次打开的时间点
        window?.localStorage?.setItem(
          `lastShowPwaInstallPopupDate${this.gameId}v2`,
          new Date().getTime()
        );
        // 打点上报
        showPopup(popupType.pwaInstallPopup);
      }
    },
    isAutoShowPwaPopup() {
    if((this.isInstall && !this.isSafari)  || this.isHideAdd) return;
      const lastShowPwaInstallPopupDate = window?.localStorage?.getItem(
        `lastShowPwaInstallPopupDate${this.gameId}v2`
      );
      if (lastShowPwaInstallPopupDate) {
        const lastDate = new Date(
          Number(lastShowPwaInstallPopupDate)
        ).getTime();
        const nowDate = new Date().getTime();
        // 如果是7天之前就展示
        if (nowDate - lastDate > 3 * 24 * 60 * 60 * 1000) {
          this.switchVisiblePwaInstallAwardPopup(true);
        }
      } else {
        this.switchVisiblePwaInstallAwardPopup(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';

.pwaInstall-box {
  position: fixed;
  z-index: 9;
  width: 400px;
  height: 50px;
  right: 0;
  top: 200px;
}

.add-to-home {
  box-sizing: border-box;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0px 11px;
  background: #771c1c;
  font-size: 22px;
  color: #ffffff;
  .ico {
    display: block;
    margin-right: 10px;
    color: #ffffff;
    font-size: 20px;
  }
  .text {
    user-select: none;
  }
}

.new-add-to-home {
  // overflow: hidden;
  float: right;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  @psetbg ('pwa-installed-award.png');
  &-text {
    margin-top: 120px;
    user-select: none;
    p {
      display: block;
      // justify-content: center;
      // align-items: center;
      font-size: 22px;
      line-height: 20px;
      padding: 0 8px;
      // 文字渐变色
      font-weight: bold;
      -webkit-background-clip: text;
      color: transparent; /* Fallback for non-webkit browsers */
      background-clip: text;
      -webkit-text-fill-color: transparent;
      &:nth-child(1) {
        margin-bottom: 8px;
        background-image: linear-gradient(to bottom, #ffe070, #ffffff);
      }
      &:nth-child(2) {
        background-image: linear-gradient(to bottom, #74d4fc, #ffffff);
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .pwaInstall-box {
    z-index: 11;
  }
  .add-to-home {
    height: 66px;
    padding: 32px 21px;
  }
}
</style>
